import { Ad } from "src/actions";
import { Adset, Campaign } from "../CreateCampaignWizard";

export interface AdCreativeFormValues {
  id: string;
  name: string;
  external_id?: string;
  adset_id?: string;
  event_id: string;
  organization_id: string;
  media_type: string;
  message: string;
  status?: string;
  campaign_id: string;
  page_id: { value: string; label: string };
  instagram_actor_id: { value: string; label: string };
  images: {
    portrait: {
      hash?: string;
      picture_url?: string;
      name?: string;
      description?: string;
      fileKey?: string;
    }[];
    square: {
      hash?: string;
      picture_url?: string;
      name?: string;
      description?: string;
      fileKey?: string;
    }[];
    // rectangle: {
    //   hash?: string;
    //   picture_url?: string;
    //   name?: string;
    //   description?: string;
    //   fileKey?: string;
    // }[];
  };
  videos: {
    portrait: {
      id?: string;
      external_id?: string;
      fileKey?: string;
      thumbnail_url?: string;
      source?: string;
    }[];
    square: {
      id?: string;
      external_id?: string;
      fileKey?: string;
      thumbnail_url?: string;
      source?: string;
    }[];
    // rectangle: {
    //   id?: string;
    //   external_id?: string;
    //   fileKey?: string;
    //   thumbnail_url?: string;
    //   source?: string;
    // }[];
  };
}

const transform = {
  input: ({
    ad,
    campaign,
    adset,
    pages,
    instagramAccounts,
  }: {
    ad?: Ad;
    campaign: Campaign;
    adset: Adset;
    pages: {
      id: string;
      name: string;
    }[];
    instagramAccounts: {
      id: string;
      username: string;
    }[];
  }): AdCreativeFormValues => {
    return {
      id: ad?.id || "",
      name: ad?.name || "",
      external_id: ad?.external_id || "",
      status: adset?.status,
      adset_id: adset?.id,
      campaign_id: campaign?.id,
      media_type: ad?.creative?.ad_formats?.includes("CAROUSEL")
        ? "carousel"
        : "single",
      event_id: adset?.event_id,
      organization_id: adset?.organization_id,
      instagram_actor_id: ad?.creative?.instagram_actor_id
        ? {
            value: ad?.creative?.instagram_actor_id,
            label: `${
              instagramAccounts.find(
                (p) => p.id === ad?.creative?.instagram_actor_id
              )?.username
            }`,
          }
        : {
            value: instagramAccounts.at(0)?.id,
            label: instagramAccounts.at(0)?.username,
          },
      page_id: ad?.creative?.page_id
        ? {
            value: ad?.creative?.page_id,
            label: `${pages.find((p) => p.id === ad?.creative?.page_id)?.name}`,
          }
        : {
            value: pages.at(0)?.id,
            label: pages.at(0)?.name,
          },

      images: {
        square:
          ad?.creative?.variations?.images.filter((i) => i.type === "square") ||
          ad?.creative.images ||
          [],
        portrait:
          ad?.creative?.variations?.images.filter(
            (i) => i.type === "portrait"
          ) || [],
        // rectangle:
        //   ad?.creative?.variations?.images.filter(
        //     (i) => i.type === "rectangle"
        //   ) || [],
      },
      videos: {
        portrait:
          ad?.creative?.variations?.videos.filter(
            (v) => v.type === "portrait"
          ) || [],
        square:
          ad?.creative?.variations?.videos.filter((v) => v.type === "square") ||
          ad?.creative?.videos ||
          [],
        // rectangle:
        //   ad?.creative?.variations?.videos.filter(
        //     (v) => v.type === "rectangle"
        //   ) || [],
      },
      message: ad?.creative?.message,
    };
  },
  output: ({
    data,
    adset,
  }: {
    data: AdCreativeFormValues;
    adset: Adset;
  }) => {
    const hasAnyImage = Object.values(data.images).some((v) =>
      v.some((v) => v.picture_url)
    );

    console.log({
      data_from_output: data,
    })

    return {
      organization_id: adset?.organization_id,
      event_id: adset?.event_id,
      campaign_id: data.campaign_id,
      external_id: data.external_id,
      id: data.id,
      adset_id: adset.id,
      name: data.name,
      creative: {
        ...data,
        ad_format:
          data.media_type === "carousel"
            ? "CAROUSEL"
            : hasAnyImage
            ? "SINGLE_IMAGE"
            : "SINGLE_VIDEO",
        instagram_actor_id: data.instagram_actor_id?.value,
        page_id: data.page_id?.value,
        images: {
          portrait: data.images.portrait.map((p) => ({
            ...p,
            picture_url: p.fileKey ? undefined : p.picture_url,
          })),
          square: data.images.square.map((p) => ({
            ...p,
            picture_url: p.fileKey ? undefined : p.picture_url,
          })),
          // rectangle: data.images.rectangle.map((p) => ({
          //   ...p,
          //   picture_url: p.fileKey ? undefined : p.picture_url,
          // })),
        },
        videos: {
          portrait: data.videos.portrait.map((p) => ({
            ...p,
            thumbnail_url: p.fileKey ? undefined : p.thumbnail_url,
            source: p.fileKey ? undefined : p.source,
          })),
          square: data.videos.square.map((p) => ({
            ...p,
            thumbnail_url: p.fileKey ? undefined : p.thumbnail_url,
            source: p.fileKey ? undefined : p.source,
          })),
          // rectangle: data.videos.rectangle.map((p) => ({
          //   ...p,
          //   thumbnail_url: p.fileKey ? undefined : p.thumbnail_url,
          //   source: p.fileKey ? undefined : p.source,
          // })),
        },
      },
    };
  },
};

export default transform;
